function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.0762,6.3389 L0.0002,10.9849 L0.0002,1.7999 C0.0002,1.4689 0.2562,1.1999 0.5712,1.1999 L0.6422,1.1999 C0.9192,1.1999 1.1422,0.9759 1.1422,0.6999 L1.1422,0.5999 C1.1422,0.2689 1.3982,-0.0001 1.7142,-0.0001 L5.1422,-0.0001 C5.4582,-0.0001 5.7142,0.2689 5.7142,0.5999 L5.7142,0.6999 C5.7142,0.9759 5.9382,1.1999 6.2142,1.1999 L15.4292,1.1999 C15.7442,1.1999 16.0002,1.4689 16.0002,1.7999 L16.0002,4.9999 L5.5692,4.9999 C4.5632,4.9999 3.6322,5.5009 3.0762,6.3389 Z M5.5693,7 L18.9153,7 C19.7783,7 20.2953,7.961 19.8183,8.682 L16.9583,13 L1.0643,13 L4.7443,7.443 C4.9273,7.167 5.2373,7 5.5693,7 Z",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 -3 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/folder.573e81e4.svg";
export { SvgComponent as ReactComponent };